// extracted by mini-css-extract-plugin
module.exports = {"header":"PageWithHeader_header__a7FwG","container":"PageWithHeader_container__UJNxk"};